<script setup>
import {computed, ref, watch} from "vue";
import {useStore} from "vuex";
import {debounce} from "lodash/function";

const store = useStore();
const search = ref('');
const filters = computed(() => store.getters['untrackedKeywords/filters']);

watch(search, debounce(async () => {
  if(search.value !== '' && search.value.length < 3) {
    return;
  }

  store.dispatch('untrackedKeywords/search', search.value);
}, 500));

const downloadCsv = computed(() => {
  const { sortBy, sortDirection, search, dateFrom, dateTo } = filters.value;

  const queryString = new URLSearchParams({
    sortBy,
    sortDirection,
    search,
    dateFrom: dateFrom,
  });

  if (dateTo) {
    queryString.append('dateTo', dateTo);
  }

  return `/keyword-scan/export?${queryString.toString()}`;
});
</script>

<template>
  <div class="tw-flex tw-justify-between">
    <div class="tw-w-1/2">
      <label class="tw-border-2 tw-border-grey-mid tw-rounded-lg tw-flex tw-text-black">
        <svg-vue
          icon="icons/search"
          class="tw-w-7 tw-h-7 tw-my-2 tw-ml-3 tw-text-grey"
        />
        <input
          v-model="search"
          type="search"
          placeholder="Search"
          class="tw-border-0 tw-w-full tw-pl-3 tw-text-lg tw-rounded-r-lg"
        >
      </label>
    </div>

    <div class="tw-flex">
      <a
        :href="downloadCsv"
        target="_blank"
        class="
            tw-flex tw-flex-row tw-items-center tw-justify-center tw-gap-2.5 tw-font-bold tw-transition-colors
            disabled:tw-cursor-not-allowed disabled:tw-text-slate-300
            tw-w-32 tw-h-10 tw-rounded-lg tw-text-blue tw-leading-normal tw-border-blue tw-border tw-shadow-blue"
      >
        Export
        <svg-vue
          icon="icons/download"
          class="tw-w-6 tw-h-6"
        />
      </a>
    </div>
  </div>
</template>

